import { Model } from 'pinia-orm';
import Job from "./Job";
import Interim from "./Interim";

export default class InterimJob extends Model {

    static get entity () {
        return 'interim-jobs';
    }

    static fields () {
        return {
            id: this.uid(() => null),
            job_id: this.attr(''),
            interim_id: this.attr(''),
            message: this.string(''),
            closed_at: this.attr(null),
            published: this.attr(false),
            start_date: this.attr(false),
            end_date: this.attr(false),
            created_at: this.attr(null),
            updated_at: this.attr(null),

            // Relationships
            job: this.belongsTo(Job, 'job_id'),
            interim: this.belongsTo(Interim, 'interim_id'),
        }
    }
}
